import * as React from "react"
import { View, useWindowDimensions, TouchableWithoutFeedback } from "react-native"
import { styles } from "./ClickableBackground.presets"

export function ClickableBackground(props: any): JSX.Element {
  const { height, width } = useWindowDimensions()
  return (
    <TouchableWithoutFeedback onPress={props.onPress}>
      <View style={[styles.ClickableBackground, { height, width }]}></View>
    </TouchableWithoutFeedback>
  )
}

export default ClickableBackground
